<div class="dialog flex-start">
  <div class="dialog__header sticky-header">
    <h3 class="dialog__title">
      <svg-icon src="assets/images/icons/{{ dialogIcon() }}" class="dialog__icon"></svg-icon>
      <span>{{ dialogTitle() | translate }}</span>
    </h3>
    <svg-icon src="assets/images/icons/x.svg" class="dialog__close" (click)="closeDialog()"></svg-icon>
  </div>
  <malfunction-card [message]="data" [showTimeElement]="false" [isEmbedded]="true"></malfunction-card>
  <div class="bottom-links sticky-footer">
    <div class="bottom-links__container">
      <a [routerLink]="['/storing-en-onderhoud']" class="blue-link" mat-dialog-close>
        <span>{{ "Overview.RecentMessages.Follow" | translate }}</span>
      </a>
    </div>
  </div>
</div>
